import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, AppleIcon, StethoscopeIcon, Gift } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: BookOpenIcon,
    badge: '🌱 EDUCACIÓN',
    badgeBg: '#e8f5e0',
    badgeColor: '#2d5a1b',
    href: '/solicitar-ayuda',
    title: 'Beca Semilla',
    description: 'Educación para padres, recursos, talleres y programas de formación para fortalecer el conocimiento familiar',
    image: 'https://cdn.magicpatterns.com/uploads/8TmgKiQadtv3HZekoT9CEJ/IMG_0429.jpg'
  }, {
    icon: AppleIcon,
    badge: '💚 SALUD',
    badgeBg: '#e8f5e0',
    badgeColor: '#2d5a1b',
    href: '/solicitar-ayuda',
    title: 'Beca Crecer',
    description: 'Acceso a consultas con especialistas, evaluaciones, estudios complementarios y segundas opiniones',
    image: 'https://cdn.magicpatterns.com/uploads/oaPED5B4LsCjnQWb9Gp6fp/ChatGPT_Image_Jul_28,_2026,_12_59_18_PM.png'
  }, {
    icon: StethoscopeIcon,
    badge: '🤝 COMUNIDAD',
    badgeBg: '#e8f5e0',
    badgeColor: '#2d5a1b',
    href: '/solicitar-ayuda',
    title: 'Alianzas Estratégicas',
    description: 'Trabajo conjunto con médicos, terapeutas y organizaciones para ampliar el acceso a servicios de calidad',
    image: 'https://cdn.magicpatterns.com/uploads/tvJQY6iF1BcpE5WX5anbH5/IMG_6854.png'
  }, {
    icon: Gift,
    badge: 'EMERGENCIAS',
    badgeBg: '#ffeeee',
    badgeColor: '#CC0000',
    href: '/venezuela-emergencia',
    title: 'Ayuda Humanitaria',
    description: 'Recolección de artículos de primera necesidad para familias afectadas por la emergencia en Venezuela.',
    image: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=400'
  }];
  return <section className="mp-becas-section" style={{
    background: 'linear-gradient(180deg, #f0fae8 0%, white 100%)',
    padding: '80px 20px'
  }} data-id="element-275" data-mp="gtofgcaenoxk">
      <div className="max-w-6xl mx-auto" data-id="element-276" data-mp="2cugnrbg0tosy">
        <p style={{
        color: '#7DC920',
        fontSize: '12px',
        letterSpacing: '3px',
        fontWeight: 700,
        textAlign: 'center',
        marginBottom: '8px'
      }} data-id="element-277" data-mp="27yhupajqzim7">
          NUESTROS PROGRAMAS
        </p>
        <h2 className="mp-becas-title" style={{
        fontSize: '38px',
        fontWeight: 800,
        color: '#1a1a1a',
        textAlign: 'center',
        marginBottom: '12px'
      }} data-id="element-278" data-mp="2vn14juig43ge">
          Becas y Programas de Apoyo
        </h2>
        <p style={{
        fontSize: '16px',
        color: '#666',
        textAlign: 'center',
        marginBottom: '48px',
        maxWidth: '640px',
        marginLeft: 'auto',
        marginRight: 'auto'
      }} data-id="element-279" data-mp="30mnh01qg9fo5">
          Diseñados para eliminar las barreras económicas que enfrentan las
          familias con niños neurodiversos
        </p>
        <div className="mp-becas-grid grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-280" data-mp="3mvccgxnjkvmk">
          {features.map(feature => <div key={feature.title} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:scale-[1.03] transition-all duration-300" style={{
          borderTop: '4px solid #7DC920'
        }} data-id="element-281" data-mp="384vejoa48nuf">
              <img src={feature.image} alt={feature.title} className="w-full h-[180px] object-cover" data-id="element-282" data-mp="344l5g2r11hbc" />
              <div className="p-6" data-id="element-283" data-mp="2u65ga5bk8i4h">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-5" data-id="element-284" data-mp="2u76rc9skt4m7">
                  <feature.icon className="w-7 h-7 text-primary" data-id="element-285" data-mp="ngz4el0gtc73" />
                </div>
                <div style={{
              background: feature.badgeBg,
              color: feature.badgeColor,
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '2px',
              padding: '4px 10px',
              borderRadius: '20px',
              display: 'inline-block',
              marginBottom: '8px'
            }} data-id="element-286" data-mp="sdpmtezqsjvo">
                  {feature.badge}
                </div>
                <h3 className="text-lg text-dark mb-3" style={{
              fontWeight: 800
            }} data-id="element-287" data-mp="25kcbzjadnhv7">
                  {feature.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4" data-id="element-288" data-mp="1rrmrjjahyl07">
                  {feature.description}
                </p>
                <Link to={feature.href} style={{
              color: '#7DC920',
              fontWeight: 600,
              fontSize: '14px',
              textDecoration: 'none'
            }} data-id="element-289" data-mp="1mt3053d4wh0g">
                  Conocer más →
                </Link>
              </div>
            </div>)}
        </div>

        <div className="mp-becas-box" style={{
        background: '#2d5a1b',
        borderRadius: '16px',
        padding: '32px 40px',
        maxWidth: '800px',
        margin: '40px auto 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px'
      }} data-id="element-290" data-mp="1hn6cgs4ud7xg">
          <div data-id="element-291" data-mp="yxhsfu2j3bwv">
            <p style={{
            fontSize: '22px',
            fontWeight: 700,
            color: 'white',
            marginBottom: '6px'
          }} data-id="element-292" data-mp="ywya4c8yulib">
              ¿Tu familia necesita apoyo?
            </p>
            <p style={{
            fontSize: '14px',
            color: 'rgba(255,255,255,0.8)'
          }} data-id="element-293" data-mp="b7njvop8s9if">
              Estamos construyendo nuestro programa oficial de becas.
            </p>
          </div>
          <Link to="/solicitar-ayuda" className="mp-becas-box-btn" style={{
          background: '#7DC920',
          color: 'white',
          fontWeight: 700,
          padding: '14px 28px',
          borderRadius: '10px',
          whiteSpace: 'nowrap',
          textDecoration: 'none'
        }} data-id="element-294" data-mp="3ucha8ev71aug">
            Solicitar Ayuda →
          </Link>
        </div>

        <div className="text-center" style={{
        marginTop: '40px'
      }} data-id="element-295" data-mp="3bgr4qho1xwbt">
          <p className="text-2xl font-bold text-dark max-w-3xl mx-auto" data-id="element-296" data-mp="3qd8fb6of36xb">
            Becas, alianzas y apoyo financiero para que ninguna familia quede
            sola.
          </p>
        </div>
      </div>
    </section>;
}